export default __webpack_public_path__ + "static/media/baunebakken-property-03.f2df2483.jpg";